import {
	PROJECT_DISPERSIONS_REQUEST,
	PROJECT_DISPERSIONS,
	PROJECT_DISPERSIONS_LOADED,
	PROJECT_DISPERSIONS_CLEAR,
	PROJECT_DISPERSIONS_FAIL
} from "../store/config";

const dispersionsInit = {
	isFetching: false,
	data:{
		list:[],
		budgets:[],
	},
	documents_items:[],
	editable: false,
	revision:{},
	permissions:{},
	error: undefined,
	timestamp: undefined
}

const dispersions = (state = dispersionsInit, action) => {
	switch (action.type) {
		case PROJECT_DISPERSIONS_REQUEST:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}
		case PROJECT_DISPERSIONS:
			return {
				...state,
				isFetching: action.isFetching,
				data:{
					...state.data,
					...action.payload,
				},
				documents_items: action.documents_items,
				editable: action.editable,
				revision: action.revision,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case PROJECT_DISPERSIONS_LOADED:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}
		case PROJECT_DISPERSIONS_CLEAR:
			return {
				...state,
				data: action.payload,
				timestamp: action.timestamp
			}
		case PROJECT_DISPERSIONS_FAIL:
			return {
				...state,
				isFetching: action.isFetching,
				error: action.error,
				timestamp: action.timestamp
			}
		default:
			return {
				...state
			}
	}
}

export default dispersions;


// WEBPACK FOOTER //
// ./src/reducers/dispersions.js